import { axiosWCApiInstance } from '../Configurations/AxiosConfiguration';

export const createExpenseDelta = async (expenseId) => {
    try {
        const response = await axiosWCApiInstance.post(`/expenses/expensedelta`, {
            expenseId: expenseId,
        });
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export default createExpenseDelta;
